var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9104 4.46545H1.09009C0.792917 4.46545 0.552002 4.70634 0.552002 5.00349V13.409C0.552002 14.8377 1.71438 16 3.14298 16H8.85734C10.286 16 11.4484 14.8377 11.4484 13.409V5.00349C11.4484 4.70637 11.2076 4.46545 10.9104 4.46545ZM4.70675 12.7593C4.70675 13.1243 4.4108 13.4203 4.04568 13.4203C3.68068 13.4203 3.3846 13.1243 3.3846 12.7593V7.70613C3.3846 7.34104 3.68063 7.04511 4.04568 7.04511C4.41077 7.04511 4.70675 7.34106 4.70675 7.70613V12.7593ZM8.61579 12.7593C8.61579 13.1243 8.31984 13.4203 7.95472 13.4203C7.58973 13.4203 7.29365 13.1243 7.29365 12.7593V7.70613C7.29365 7.34104 7.58967 7.04511 7.95472 7.04511C8.31982 7.04511 8.61579 7.34106 8.61579 7.70613V12.7593Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3712 0.837176H8.02729V0.633909C8.02729 0.284366 7.74297 0 7.39346 0H4.60676C4.25722 0 3.97285 0.284366 3.97285 0.633909V0.837176H1.62896C0.731443 0.837176 0.0012207 1.56735 0.0012207 2.46489V3.50865C0.0012207 3.69532 0.152541 3.84667 0.339286 3.84667H11.661C11.8476 3.84667 11.9989 3.69532 11.9989 3.50865V2.46489C11.9989 1.56737 11.2688 0.837176 10.3712 0.837176Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.2f4a5e6caed69d5b3a01abe7204e7023.svg";
export { ForwardRef as ReactComponent };